<!DOCTYPE html>

@if (loaded) {
<ion-content #pageBottom class="payment-wrapper">
  @if (!paymentPageData) {
  <div class="skeleton-loader">
    <ion-grid>
      <ion-row>
        <ion-col>
          <div class="skeleton-header"></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="skeleton-price-bar"></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="skeleton-card-list"></div>
          <div class="skeleton-card-list"></div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  }
  <ion-grid class="payment-header-wrapper">
    <div [innerHTML]="paymentPageData | safeHtml"></div>
    @if (addNewCardInProgress) {
    <ion-row class="payment-bar">
      <ion-col> {{'request-dialog.total' | translate}} {{ formatCurrencyAmountDisplay((( totalPrize$ | async ) &gt; 0 ?
        (
        totalPrize$ | async ) :
        (purchaseDetail?.offers?.int_price?.[preferredCurrency]) ?
        (purchaseDetail?.offers?.int_price?.[preferredCurrency]) :
        (purchaseDetail?.offers?.price))) }}
      </ion-col>
    </ion-row>
    }
  </ion-grid>
  @if (fourCPaymentAlert) {
    <div
      class="four-c-payment-alert"
      [class.four-c-payment-alert--success]="fourCPaymentAlert.severity === 'success'"
      [class.four-c-payment-alert--error]="fourCPaymentAlert.severity === 'error'"
      [class.four-c-payment-alert--info]="fourCPaymentAlert.severity === 'info'"
      [class.four-c-payment-alert--warning]="fourCPaymentAlert.severity === 'warning'"
      [class.four-c-payment-alert--action_required]="fourCPaymentAlert.severity === 'action_required'"
      role="alert"
    >
      <div class="four-c-payment-alert__icon" aria-hidden="true">
        @switch (fourCPaymentAlert.severity) {
          @case ('success') {
            <span>✓</span>
          }
          @case ('info') {
            <span>i</span>
          }
          @case ('warning') {
            <span>!</span>
          }
          @default {
            <span>×</span>
          }
        }
      </div>
      <div class="four-c-payment-alert__text">
        <div class="four-c-payment-alert__title">{{ fourCPaymentAlert.line1 }}</div>
        @if (fourCPaymentAlert.line2) {
        <div class="four-c-payment-alert__subtitle">{{ fourCPaymentAlert.line2 }}</div>
        }
      </div>
    </div>
    }
  <!-- [UI] Update Addons Section start -->
  @if (upsellList && (upsellList?.length > 0) && purchaseDetail?.p_type == p_id) {
  <div class="upsell-container">
    <h4>{{ "payment.addons-title" | translate }}</h4>
    @for (addOnList of upsellList; track addOnList; let i = $index) {
    <ion-row class="splitter-line-bottom">
      <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="checkbox-area">
        <ion-checkbox mode="ios" color="secondary" [(ngModel)]="addOnList.is_default"
          [value]="addOnList?.price[preferredCurrency]" (ionChange)="checkBoxChanged($event, addOnList)">
        </ion-checkbox>
      </ion-col>
      <ion-col size="8" size-md="10" size-lg="10" size-xl="10" class="details"
        [innerHTML]="addOnList?.html_msg[selectedLanguage] | safeHtml">
      </ion-col>
      <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="price-value">
        <strong> {{currencySymbol}}{{addOnList?.price[preferredCurrency]}} </strong>
      </ion-col>
    </ion-row>
    }
  </div>
  } @else {
  @if (purchaseDetail?.offers?.add_on && (purchaseDetail?.offers?.add_on.length > 0) &&
  !purchaseDetail?.offers?.prize_draw_flow && !showHorizonalUpsell) {
  <div class="upsell-container">
    <h4>{{ "payment.addons-title" | translate }}</h4>
    @for (addOnList of purchaseDetail?.offers?.add_on; track addOnList; let i = $index) {
    <ion-row class="splitter-line-bottom">
      <ion-col size="2" size-md="1" size-lg="1" size-xl="1" class="checkbox-area">
        <ion-checkbox mode="ios" color="secondary" [(ngModel)]="addOnList.is_default"
          [value]="addOnList?.price[preferredCurrency]" (ionChange)="checkBoxChanged($event, addOnList)">
        </ion-checkbox>
      </ion-col>
      <ion-col size="7" size-md="9" size-lg="9" size-xl="9" class="details"
        [innerHTML]="(addOnList?.trans_html_msg?.[languageCode]?.trim() || addOnList?.html_msg) | safeHtml">
      </ion-col>
      <ion-col size="3" size-md="2" size-lg="2" size-xl="2" class="price-value ion-text-end">
        <strong> {{currencySymbol}}{{addOnList?.price[preferredCurrency]}} </strong>
      </ion-col>
    </ion-row>
    }
  </div>
  }
  }
  <!-- [UI] Update Addons Section end -->
  <!-- [UI] upsell slider start -->
  @if (purchaseDetail?.offers?.add_on && showHorizonalUpsell) {
  <div class="upsell-slider-wrapper">
    <h3 class="block-title">{{ "payment.Exclusive_deals" | translate }}</h3>
    <swiper [config]="storeSliderOptions2">
      @for (offersDeals of purchaseDetail?.offers?.add_on; track offersDeals) {
      <ng-template swiperSlide>
        <div [ngClass]="issChecked() ? 'added-card':''" class="bonus-slide"
          [innerHTML]="offersDeals?.html_msg_horizontal | safeHtml">
        </div>
      </ng-template>
      }
      <ng-template swiperSlide>
        <div> - </div>
      </ng-template>
    </swiper>
  </div>
  }
  <!-- [UI] upsell slider End-->
  <!-- old Upsel code start -->
  <!-- old Upsel code end -->
  <!-- [UI] Addons Section for prize_draw_flow Start -->
  @if (purchaseDetail?.offers?.add_on && (purchaseDetail?.offers?.add_on.length > 0) &&
  purchaseDetail?.offers?.prize_draw_flow === true) {
  <div class="selection-card">
    <span>{{ "payment.Million_shot" | translate }}</span>
    @for (addOnList of purchaseDetail?.offers?.add_on; track addOnList; let i = $index) {
    <div class="mm-row">
      <div class="checkbox-wrapper">
        <div class="round"> <ion-checkbox type="checkbox" id="checkbox-1" style="padding: 0; margin: 0" mode="ios"
            color="secondary" [value]="addOnList?.price[preferredCurrency]"
            (ionChange)="checkBoxChanged($event, addOnList)" />
          <label for="checkbox-1"></label>
        </div>
      </div>
      <div class="text-wrapper" [innerHTML]="addOnList?.html_msg | safeHtml">
      </div>
      <div class="mm-price">{{currencySymbol}}{{addOnList?.price[preferredCurrency]}}</div>
    </div>
    }
  </div>
  }
  <!-- [UI] Addons Section for prize_draw_flow End -->
  @if (!addingCard) {
  <div class="cardlist-wrapper">
    @if (paymentDetails) {
    <div>
    @if (!showSlideToBuy()) {
      @for (card of storedCards.slice(0, 2); track card; let i = $index) {
      <ion-item lines="none" class="card-data ion-no-padding" [hidden]="!showAll && i > 1">
        <ion-row class="">
          <ion-col size="3" size-sm="2" class="image-column">
            <img decoding="async" loading="lazy" [src]="card?.card_image" alt="{{ card?.card_type }}"
              class="card-image" />
          </ion-col>
          <ion-col size="6" class="card-number">*** *** **** {{ card.card_short_number }}</ion-col>
          <ion-col size="3" class="checkbox-area">
            <ion-checkbox class="select-method-checkbox" color="secondary" [(ngModel)]="card.isChecked"
              (ngModelChange)="changeCheckCard(storedCards, i)"></ion-checkbox>
          </ion-col>
        </ion-row>
      </ion-item>
      }
       <!-- Add New Card -->
      <ion-item lines="none">
        <div class="add-payment-wrapper" style="width: 100%; text-align: right; color: #68b6f3">
          @if (!addNewCardInProgress && showAddNewCard) {
          <p (click)="addNewCard()" class="add-payment-method">
            {{ "payment.Add" | translate }}
          </p>
          }
          @if (addNewCardInProgress) {
          <ion-spinner name="lines-small" class="sign-in-spinner" duration="2000"
            style="color: blue; margin-right: 1vh"></ion-spinner>
          }
        </div>
      </ion-item>
      }
    </div>
    } @else {
    <app-in-progress-animation></app-in-progress-animation>
    }
  </div>
  } @else {
  <!-- <div style="height: 200px">
      <div style="position: absolute; width: 92%; text-align: center">
        <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh"> </ion-spinner>
      </div>
      <form action="http://localhost:8100/store/r" class="paymentWidgets" data-brands="VISA MASTER"></form>
    </div> -->
  @if (!isCheckoutCom) {
  <div style="
        padding: 0.3vh;
        border-radius: 2vh;
        min-height: 25vh;
        width: 97%;
        margin-left: 1.5%;
        margin-top: 1vh;
        height: auto;
      ">
    <div class="timer-counter">
      <div class="d-flex">
        <img src="../../../assets/icon/lock key.webp" decoding="async" loading="lazy" alt="" class="lock" />
        <p>{{ "add-new-card.Secure" | translate }}</p>
      </div>
      <div>{{ "add-card.time_left" | translate }}: <span #timer></span></div>
    </div>
    <div [ngClass]="isPaymentDone ? 'show' : 'hide'" style="visibility: hidden">
      <iframe style="border: 0; width: 100%; height: 100vh; padding: 1vh" #iframe id="myCustomIframe1"
        name="myCustomIframe1" (load)="load(iframe)"
        sandbox="allow-forms allow-modals allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation">
      </iframe>
    </div>
    @if (!isPaymentDone) {
    <div>
      <div style="position: absolute; width: 92%; text-align: center">
        @if (addNewCardInProgress) {
        <ion-spinner name="lines-small" diameter="40" style="color: green; margin-top: 4vh">
        </ion-spinner>
        }
      </div>
      <form action="{{ origin + '/r' }}" class="paymentWidgets" data-brands="VISA MASTER"></form>
    </div>
    }
  </div>
  }
  @if (isCheckoutCom && !checkoutPaymentSuccess) {
  <div [ngClass]="{
      'fixed-footer': fixFooter,
      'checkout_gateway': isCheckoutComform,
      'sticky-payment-iframe': isStickyCTAEnabled && isCheckoutComform
    }"
    >
    <div [innerHTML]="showVisaInfoHTML"></div>
    <div class="timer-section-wrapper">
      <div class="d-flex left-wrap">
        <img src="../../../assets/icon/lock key.webp" decoding="async" loading="lazy" alt="" class="lock" />
        <p> {{ "add-card.secure_payment" | translate }}</p>
      </div>
      <div>
        <h3 class="payment-no">{{'payment.Payable' | translate }} - {{ formatCurrencyAmountDisplay(((( totalPrize$ |
          async ) &gt;
          0 ? ( totalPrize$ | async ) + totalOfferPrizeValue :
          (purchaseDetail?.offers?.int_price?.[preferredCurrency]) ?
          (purchaseDetail?.offers?.int_price?.[preferredCurrency]) + totalOfferPrizeValue :
          totalOfferPrizeValue + (purchaseDetail?.offers?.price)))) }} </h3>
      </div>
    </div>
    <!-- Keep #cko-flow-container mounted ([hidden] vs @if) so Checkout.com Flow/Frames
         teardown does not crash the SDK (LOTTOSOCIAL-PWA-1N9X / HATDEV-99039). -->
    <form id="payment-form" [hidden]="!isCheckoutComform" (submit)="onSubmit($event)">
      <ng-container>
        @if (purchaseDetail?.offers?.card_verification === true) {
        <p>
          By selecting Pay with Card, you agree to save your card and start the recurring membership
          described above after the free period. You can cancel before the first billing date.
        </p>
        }
        <div class="one-liner">
          <div id="cko-flow-container" class="cko-flow-container checkout_gateway"></div>
        </div>
        @if (errorMessage) {
        <div class="message">
          @if (isCheckoutLoadingMessage(errorMessage) && showCheckOutComSpinner) {
          <ion-spinner name="lines-small" class="checkout-inline-spinner" role="status" aria-label="Loading payment form"></ion-spinner>
          }
          <p [ngClass]="isCheckoutLoadingMessage(errorMessage) ? 'loading-message' : 'error-message'">{{ errorMessage }}</p>
        </div>
      }@else if (!errorMessage && showCheckOutComSpinner) {
        <div class="timer-section-loader" aria-live="polite" aria-busy="true">
          <ion-spinner name="lines-small" class="timer-section-spinner" role="status" aria-label="Loading payment"></ion-spinner>
          <p class='loading-message'> Loading payment form...</p>
        </div>
      }
      </ng-container>
    </form>
    <iframe
      [ngStyle]="{ 'height': isCheckoutComform ? '0vh' : '100vh', 'pointer-events': isCheckoutComform ? 'none' : 'auto' }"
      style="border: 0; width: 100%; padding: 1vh;"
      id="checkoutAuthorizationIframe"
      name="checkoutAuthorizationIframe"
      [src]="redirectlink"
      #checkOutIframe>
    </iframe>
  </div>
  }
  <ion-row>
    <ion-col>
      <p class="text-button" (click)="openNoThanks()">{{'payment.No' | translate }}</p>
      @if (hasTrustpilotReviews()) {
      <div class="tr-review-card">
        <div class="tr-header">
          <div class="tr-trustpilot">
            <img
              decoding="async"
              loading="lazy"
              src="../../../../assets/trustpilot.svg"
              alt="Trustpilot logo"
              class="tr-logo"
            />
          </div>

          <div class="tr-rating">
            <div class="tr-top">
              <span class="tr-excellent">{{ 'payment.excellent' | translate }}</span>
              <span class="tr-stars">★★★★★</span>
            </div>
            <div class="tr-bottom" [innerHTML]="'payment.reviews' | translate"></div>
          </div>
        </div>

        <div class="tr-reviews">
          @for (review of getTrustpilotReviews(); track review; let last = $last) {
          <div class="tr-review">
            <div class="tr-stars yellow">★★★★★</div>
            <div [innerHTML]="getReviewText(review) | safeHtml"></div>
            <div class="tr-author" [innerHTML]="getReviewUser(review) | safeHtml"></div>
          </div>
          @if (!last) {
          <div class="tr-divider"></div>
          }
          }
        </div>
      </div>
      }
      <p class="disclaimer-text">
        {{'payment.Hatchster' | translate }}
      </p>
    </ion-col>
  </ion-row>
  }
  @if (!addNewCardInProgress) {
  <ion-grid class="payment-footer-wrapper" [ngClass]="{ 'sticky-footer': isStickyCTAEnabled }">
    <ion-row class="payment-bar">
      <ion-col> {{'payment.Payable' | translate }} </ion-col>
      <ion-col> {{ formatCurrencyAmountDisplay(((( totalPrize$ | async ) &gt; 0 ? ( totalPrize$ | async ) +
        totalOfferPrizeValue
        :
        (purchaseDetail?.offers?.int_price?.[preferredCurrency]) ?
        (purchaseDetail?.offers?.int_price?.[preferredCurrency]) + totalOfferPrizeValue :
        totalOfferPrizeValue + (purchaseDetail?.offers?.price)))) }} </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
                  <!-- slide btn -->
        @if (showSlideToBuy()) {
          <div class="slider-container" [class.activated]="isSlideInteractionDisabled()">
            <div class="slider-text" [ngClass]="btnClass">{{ swipeToBuyBtn | translate}}</div>
            <div
              #slide_btn
              class="slider"
              [class.slider-disabled]="isSlideInteractionDisabled()"
              (touchstart)="onSliderTouchStart($event)"
              (touchmove)="onSliderTouchMove($event)"
              (touchend)="endDrag()"
              (touchcancel)="endDrag()"
              (mousedown)="onSliderMouseDown($event)"
            >
              <img src="assets/gif/rightarrow1.gif" alt="right arrow icon" />
            </div>
        </div>
        } @else if (showStoredCardPay()) {
        <ion-button size="small" expand="block" class="pay-btn" (click)="proceedToPay()" [hidden]="isPaymentDone" [disabled]="!canUseStoredCard()">
          @if (!spinnerAnimation && proceed) {
          <mat-icon class="lock-icon">{{ "add-payment.lock" | translate }}</mat-icon>
          {{'payment.pay' | translate }}
          }
          @if (spinnerAnimation) {
          <div class="spinners">
            <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
            </mat-progress-spinner>
            <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
            </mat-progress-spinner>
          </div>
          }
          @if (!proceed) {
          <mat-icon [@bounceIn] class="tick-mark">{{ "add-card.done" | translate }}</mat-icon>
          }
        </ion-button>
      }
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid>
    <ion-row>
      <ion-col>
        <p class="text-button" (click)="openNoThanks()">{{'payment.No' | translate }}</p>
        @if (!addingCard && hasTrustpilotReviews()) {
          <div class="tr-review-card">
            <div class="tr-header">
              <div class="tr-trustpilot">
                <img
                  decoding="async"
                  loading="lazy"
                  src="../../../../assets/trustpilot.svg"
                  alt="Trustpilot logo"
                  class="tr-logo"
                />
              </div>

              <div class="tr-rating">
                <div class="tr-top">
                  <span class="tr-excellent">{{ 'payment.excellent' | translate }}</span>
                  <span class="tr-stars">★★★★★</span>
                </div>
                <div class="tr-bottom" [innerHTML]="'payment.reviews' | translate"></div>
              </div>
            </div>

            <div class="tr-reviews">
              @for (review of getTrustpilotReviews(); track review; let last = $last) {
              <div class="tr-review">
                <div class="tr-stars yellow">★★★★★</div>
                <div [innerHTML]="getReviewText(review) | safeHtml"></div>
                <div class="tr-author" [innerHTML]="getReviewUser(review) | safeHtml"></div>
              </div>
              @if (!last) {
              <div class="tr-divider"></div>
              }
              }
            </div>
          </div>
        }
        <p class="disclaimer-text">{{'payment.Hatchster' | translate }}</p>
      </ion-col>
    </ion-row>
  </ion-grid>
  }
  <ng-template #loading>
    <app-in-progress-animation></app-in-progress-animation>
  </ng-template>
</ion-content>
<div class="pay-success">
  <img src="assets/gif/final_lottie.gif" alt="Success animation">
</div>
}